import { Card } from '../ui/Card'
import { WidgetHeader } from './WidgetKommende'

interface BillingSummary {
  leje_oere: number
  forbrug_oere: number
  ovrige_oere: number
  total_oere: number
}

interface WidgetOpkraevningProps {
  summary: BillingSummary | null
  loading: boolean
  editMode?: boolean
}

function formatDKK(oere: number): string {
  return new Intl.NumberFormat('da-DK', {
    style: 'currency', currency: 'DKK', maximumFractionDigits: 0,
  }).format(oere / 100)
}

export function WidgetOpkraevning({ summary, loading, editMode }: WidgetOpkraevningProps) {
  const total = summary?.total_oere ?? 0

  const lejeWidth = total > 0 ? Math.round(((summary?.leje_oere ?? 0) / total) * 100) : 0
  const forbrugWidth = total > 0 ? Math.round(((summary?.forbrug_oere ?? 0) / total) * 100) : 0
  const ovrigeWidth = Math.max(0, 100 - lejeWidth - forbrugWidth)

  return (
    <Card
      padding="none"
      style={editMode ? { border: '1.5px dashed #4f46e5', background: '#fafbff' } : undefined}
    >
      <WidgetHeader title="Månedlig opkrævning — split" />
      <div style={{ padding: '10px 16px' }}>
        {loading ? (
          <div style={{ color: '#94a3b8', fontSize: 12 }}>Henter…</div>
        ) : summary === null ? (
          <div style={{ color: '#94a3b8', fontSize: 12, padding: '8px 0' }}>Ingen data.</div>
        ) : (
          <>
            {/* Stacked bar */}
            <div style={{
              display: 'flex', gap: 2, marginBottom: 10,
              borderRadius: 4, overflow: 'hidden', height: 12,
            }}>
              <div style={{ flex: lejeWidth, background: '#4f46e5', minWidth: lejeWidth > 0 ? 4 : 0 }} />
              <div style={{ flex: forbrugWidth, background: '#0284c7', minWidth: forbrugWidth > 0 ? 4 : 0 }} />
              <div style={{ flex: ovrigeWidth, background: '#16a34a', minWidth: ovrigeWidth > 0 ? 4 : 0 }} />
            </div>
            {/* DKK rows */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {[
                { label: 'Leje', color: '#4f46e5', amount: summary?.leje_oere ?? 0 },
                { label: 'Aconto (forbrug)', color: '#0284c7', amount: summary?.forbrug_oere ?? 0 },
                { label: 'Øvrige bidrag', color: '#16a34a', amount: summary?.ovrige_oere ?? 0 },
              ].map(({ label, color, amount }) => (
                <div key={label} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <div style={{ width: 8, height: 8, borderRadius: 2, background: color, flexShrink: 0 }} />
                    <span style={{ color: '#64748b', fontSize: 12 }}>{label}</span>
                  </div>
                  <span style={{ fontWeight: 600, color: '#0f172a', fontSize: 12 }}>{formatDKK(amount)}</span>
                </div>
              ))}
              <div style={{
                marginTop: 2, paddingTop: 6, borderTop: '1px solid #f1f5f9',
                display: 'flex', justifyContent: 'space-between',
              }}>
                <span style={{ fontWeight: 600, color: '#64748b', fontSize: 12 }}>Total</span>
                <span style={{ fontWeight: 700, color: '#0f172a', fontSize: 13 }}>{formatDKK(total)}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </Card>
  )
}
